import mitt from 'mitt'

const emitter = mitt()

// add $on, $off, $emit methods so old Vue-bus style works
const Bus = {
    $on: emitter.on,
    $off: emitter.off,
    $emit: emitter.emit
}

export default {
    install(app) {
        app.config.globalProperties.$bus = Bus
    }
}

export { Bus }
